import BOFAS from "../documents/Cat_Flood_BOFAS.pdf";
import EFORT from "../documents/EFORT_Pain_Diary_Abstract.pdf";
import OPAs from "../documents/Saving_OPAs_after_Injections_in_MSK.pdf";
import EFASPoster from "../documents/eposter_efascongress_2022.pdf";

import type { Watch } from "@/definitions/diaryTypes";

interface Prize {
	name: string;
	href: string;
}

export type StudyStatus = "completed" | "underway" | "upcoming";

export interface EvidenceItem {
	title: string;
	heading?: string;
	description: string;
	publisher: string;
	href?: string;
	date: string;
	startDate?: string;
	endDate?: string;
	watch: Watch;
	participants: number;
	prize?: Prize;
	headline?: boolean;
	status?: StudyStatus;
	duration?: string;
}

export const content: EvidenceItem[] = [
	{
		title: "Arthrosamid Performance Monitoring for Osteoarthritis",
		description:
			"Ongoing collaborative project with Citius achieving complete patient compliance in monitoring Arthrosamid treatment outcomes for osteoarthritis using digital pain diaries.",
		publisher: "Citius Collaboration",
		participants: 0, // Update with actual participant count when available
		date: "May 2025 - November 2026",
		startDate: "2025-05-01",
		endDate: "2026-11-01",
		watch: "PAIN",
		status: "upcoming",
		duration: "18 months",
	},
	{
		title: "Spine Study with Sheffield NHS Trust",
		description:
			"Upcoming comprehensive spine treatment monitoring study in collaboration with Sheffield NHS Trust, tracking patient outcomes using digital pain diaries.",
		publisher: "Sheffield NHS Trust",
		participants: 50,
		date: "June 2025 - October 2025",
		startDate: "2025-06-02",
		endDate: "2025-10-02",
		watch: "PAIN",
		status: "upcoming",
		duration: "4 months",
	},
	{
		title: "Heel Pain Study",
		description:
			"Upcoming study focused on monitoring heel pain treatment outcomes and patient recovery patterns using digital tracking methods.",
		publisher: "Patient Watch",
		participants: 0, // Update with actual participant count when available
		date: "May 2025 - November 2025",
		startDate: "2025-05-29",
		endDate: "2025-11-29",
		watch: "FOOT",
		status: "upcoming",
		duration: "6 months",
	},
	{
		title: "Wasting Everyone's Time (v1)",
		description:
			"This study of 108 orthopaedic surgeons shows that routine follow-up appointments after injection are widely used, but are wasteful and inefficient.",
		publisher: "EFAS",
		href: EFASPoster,
		participants: 108,
		date: "March 2022",
		startDate: "2022-03-20",
		endDate: "2022-03-20",
		watch: "PAIN",
		status: "completed",
	},
	{
		title: "Wasting Everyone's Time (v2)",
		heading: "85% of surgeons schedule unnecessary routine follow-up.",
		description:
			"This prize winning poster shows how 85% of surgeons schedule routine follow-up appointments after injections despite these appointments being unnecessary.",
		publisher: "BOFAS",
		href: BOFAS,
		participants: 271,
		date: "March 2023",
		startDate: "2023-03-10",
		endDate: "2023-03-10",
		prize: {
			name: "2nd Prize for Best Poster",
			href: "https://www.bofas.org.uk/clinician/meetings/past-congresses/bofas-2023/bofas-2023-scientific-papers",
		},
		headline: true,
		watch: "PAIN",
		status: "completed",
	},
	{
		heading: "3000+ injections at RSCH NHS Trust each year",
		title: "Ultrasound Guided Injections in Muscloskeletal Care",
		description:
			"This retrospective study of PACs data, showed the Royal Surrey did 3420 joint injections in 2019. This excluded OPD and theatre injections.",
		publisher: "Internal Audit",
		participants: 3420,
		date: "March 2021",
		startDate: "2021-03-20",
		endDate: "2021-03-20",
		href: OPAs,
		headline: true,
		watch: "PAIN",
		status: "completed",
	},
	{
		publisher: "EFORT",
		title: "Efficient Follow-Up After Orthopaedic Injections.",
		heading:
			"Only 9% of patients in this study benefitted from routine follow-up.",
		description:
			"The number of saved appointments for a surgeon was calculated by comparing patient pain diary results to patient appointments over 3 years.",
		date: "May 2022",
		startDate: "2022-05-15",
		endDate: "2022-05-15",
		participants: 104,
		href: EFORT,
		headline: true,
		watch: "PAIN",
		status: "completed",
	},
];
